import Arrow from './arrow.svg';
import Bird from './bird.svg';
import Boarding from './boarding.svg';
import Breeder from './breeder.svg';
import Bullet from './bullet.svg';
import Calender from './calender.svg';
import Cat from './cat.svg';
import Charity from './charity.svg';
import Close from './close.svg';
import Copy from './copy.svg';
import CurrentLocation from './current-location.svg';
import Daycare from './daycare.svg';
import Directions from './directions.svg';
import DiscountCoupon from './discount-coupon.svg';
import Distance from './distance.svg';
import DogWalking from './dog-walking.svg';
import Dog from './dog.svg';
import Email from './email.svg';
import FacebookCircle from './facebook-circle.svg';
import Facebook from './facebook.svg';
import Filter from './filter.svg';
import Google from './google.svg';
import Grooming from './grooming.svg';
import Information from './information.svg';
import Instagram from './instagram.svg';
import Linkedin from './linkedin.svg';
import Loader from './loader.svg';
import LoadingIcon from './loading-icon.svg';
import Location from './location.svg';
import Map from './map.svg';
import Menu from './menu.svg';
import Modelling from './modelling.svg';
import Offline from './offline.svg';
import Open from './open.svg';
import PataP from './pata-p.svg';
import PawFull from './paw-full.svg';
import Paw from './paw.svg';
import PetService from './pet-service.svg';
import PetStore from './pet-store.svg';
import Pets from './pets.svg';
import Phone from './phone.svg';
import PinLight from './pin-light.svg';
import Pin from './pin.svg';
import Rabbit from './rabbit.svg';
import Rating from './rating.svg';
import Reddit from './reddit.svg';
import Reptile from './reptile.svg';
import Rodent from './rodent.svg';
import Search from './search.svg';
import Share from './share.svg';
import Sitting from './sitting.svg';
import StarEmpty from './star-empty.svg';
import Star from './star.svg';
import Training from './training.svg';
import Twitter from './twitter.svg';
import Vet from './vet.svg';
import ViewMap from './view-map.svg';
import Website from './website.svg';
import Whatsapp from './whatsapp.svg';
import Youtube from './youtube.svg';

const icons: { [key: string]: React.FC } = {
  Arrow,
  Breeder,
  Boarding,
  PetService,
  Bullet,
  Calender,
  Close,
  Copy,
  Charity,
  CurrentLocation,
  Daycare,
  Directions,
  DiscountCoupon,
  Distance,
  Dog,
  DogWalking,
  Email,
  Facebook,
  LoadingIcon,
  FacebookCircle,
  Filter,
  Google,
  Grooming,
  Instagram,
  Linkedin,
  Loader,
  Location,
  Map,
  Menu,
  Modelling,
  Open,
  PataP,
  Paw,
  PawFull,
  Pets,
  PetStore,
  Phone,
  Pin,
  PinLight,
  Rating,
  Reddit,
  Search,
  Share,
  Sitting,
  Star,
  StarEmpty,
  Training,
  Twitter,
  Vet,
  ViewMap,
  Website,
  Whatsapp,
  Youtube,
  Offline,
  Cat,
  Rodent,
  Reptile,
  Bird,
  Rabbit,
  Information,
};

export default icons;
